import { DealDetailScreenContent } from "../../features/deals";

function DealDetailScreen() {
  return (
    <section className="clients-page" id="Csection" tabIndex="-1">
      <div className="container">
        <DealDetailScreenContent />
      </div>
    </section>
  );
}

export default DealDetailScreen;
